import store from '@store/index';
import { setAlert } from '@store/appStore';
import { translateFirebaseError } from '@utils/Alerts/Error/firebaseErrors';

export const showAlertError = (error: any) => {
    let errorMessage = 'Ocurrió un error desconocido.';

    if (error.code) {
        errorMessage = translateFirebaseError(error.code);
    } else if (error.reason) {
        errorMessage = error.reason;
    } else if (error.message) {
        errorMessage = error.message;
    } else if (error) {
        errorMessage = error.toString();
    }

    store.dispatch(
        setAlert({
            message: errorMessage,
            severity: 'error',
            open: true
        })
    );
};
